export default __webpack_public_path__ + "static/SPC-7492e0978acdbf84694e5540c04c67ff.png";